module.exports = __webpack_public_path__ + "img/credit-card-secure-2.d50609c0.png";